import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { WelletContext } from '@/context/wellet/welletContext';
import { hasAllowedRoles } from '@/helpers/roles';
import { useUser } from '@/hooks';
import { putConciergeCommission } from '@/services';
import { CardForm, InputCheckboxForm, InputNumberForm, Toast } from '@/uiComponents/common';
import { useContext } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';

const LoyaltyCommissionCard = ({ className, userQuery, id }) => {
  const welletContext = useContext(WelletContext);
  const { t: translate } = useTranslation('translation', { keyPrefix: 'forms.userForm' });
  const { t } = useTranslation('translation', { keyPrefix: 'screens.profile' });
  const organization = useSelector((state) => state.app.selectedOrganization);
  const { roles } = useUser();
  const resetData = (data) => {
    const body = {
      sid: data?.sid,
      commissionPlusPercentage: data?.commissionPlusPercentage,
      isCommissionDisabled: data?.isCommissionDisabled,
    };
    return body;
  };

  const methods = useForm({
    defaultValues: resetData(userQuery?.data?.data),
  });

  const isCommissionDisabled = methods.watch('isCommissionDisabled');

  const onSubmit = (data) => {
    const body = {
      userId: id,
      extraCommission: Number(data.commissionPlusPercentage) ?? null, // VA
      isCommissionDisabled: data.isCommissionDisabled ? data.isCommissionDisabled : false, // VA
    };
    userMutation.mutate(body);
  };

  const userMutation = useMutation({
    mutationFn: (body) => {
      //   if (id === false) return postUser(welletContext, body);
      return putConciergeCommission(welletContext, organization.marketId, body);
    },
    onSuccess: () => userQuery.refetch(),
  });

  return (
    <>
      <FormProvider {...methods}>
        <form key={'loyalty'} onSubmit={methods.handleSubmit(onSubmit)}>
          <CardForm
            title={t('comissionCard.title')}
            subtitle={t('comissionCard.subtitleScheme')}
            className={className}
            endComponent={
              hasAllowedRoles(roles, [
                'superadministrator',
                'marketadmin',
                'affiliatecenter',
              ]) ? (
                <Button disabled={!userMutation.isIdle}>{t('submit')}</Button>
              ) : null
            }
          >
            <div className='row'>
              <div className='col-12 tw-mb-6'>
                <Label className='!tw-mb-3'>{t('rowCommissions.title')}</Label>
                <InputCheckboxForm
                  name={'isCommissionDisabled'}
                  label={translate('inputModernSwithcer.label')}
                />
              </div>

              <div className='col-12'>
                <InputNumberForm
                  name={'commissionPlusPercentage'}
                  className='mb-0'
                  currencySymbol={'%'}
                  label={translate('inputComissionsPercentage.label')}
                  maxNumber={100}
                  minNumber={-100}
                  isDisabled={isCommissionDisabled}
                  placeholder={translate('inputComissionsPercentage.placeholder')}
                />
              </div>
            </div>
          </CardForm>
        </form>
      </FormProvider>
      {userMutation.isSuccess ? (
        <Toast
          type={'SUCCESS'}
          message={t('comissionCard.toast.success')}
          onCallback={() => userMutation.reset()}
        />
      ) : null}
      {userMutation.isError ? (
        <Toast type={'ERROR'} message={t('toast.error')} onCallback={() => userMutation.reset()} />
      ) : null}
    </>
  );
};

export default LoyaltyCommissionCard;
